export default __webpack_public_path__ + "static/media/profile.05e1214c.jpg";